export default __webpack_public_path__ + "static/media/profileUser.41697934.png";